module.exports = "/static/assets/ec5a678c6318ecbe41949e7e89ae50cf.png";